import { api, apiRoutes } from "../../api";
import {
  getPostsStore,
  setPostsStore,
  setPostsStoreField,
} from "./components/Posts";
import { getTopicsStore } from "./components/Topics";

export const fetchGetPosts = async () => {
  try {
    const { page, currentPage  } = getPostsStore();
    const { searchingTopics } = getTopicsStore();
    const { data } = await api.post(
      apiRoutes.getPosts(),
      { topics: searchingTopics },
      { params: { currentPage: page, type: currentPage } }
    );
		console.log('data.posts', data.posts)
    setPostsStoreField("posts", (v) => [...v, ...data.posts]);
    setPostsStore({ totalPages: data.totalPages, isFetching: false });
  } catch (err) {
  } finally {
    setPostsStore({ isLoading: false });
  }
};
